// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';
import ActionTypes from 'constants/ActionTypes';

import PMTApiRestaurant from 'PMT/api/ApiRestaurant';
import PMTApiRole from 'PMT/api/ApiRole';
import PMTApiRestaurantsGroup from 'PMT/api/ApiRestaurantsGroup';

import { RestaurantStore, SessionStore } from 'stores';

import { RestaurantsGroup } from 'PMT/entities/restaurantsGroup';
import { ProRolesList, ProRole } from 'PMT/entities/security';
import Restaurant from 'PMT/entities/Restaurant';
import ApiError from 'PMT/entities/ApiError';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';


/**
 * TODO: Move restaurantsGroup and roles to own actions.
 */
export default class RestaurantAction {

  static retrieveCurrentRestaurant() {
    this.retrieveRestaurant(RestaurantStore.getRestaurantId());
  }

  static retrieveRestaurant(restaurantId: string) {
    PMTApiRestaurant.getRestaurant(
      restaurantId,
      RestaurantAction.receiveRestaurant,
      RestaurantAction.receiveRestaurantError
    );
  }

  static receiveRestaurant(restaurant: Restaurant) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_SUCCESS,
      restaurant
    });
  }

  static receiveRestaurantError(apiError: ApiError) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_FAILURE,
      apiError
    });
  }

  //
  //
  //
  static retrieveRestaurantForGroup(restaurant: Restaurant, restaurantsGroup: RestaurantsGroup) {
    // Do not remove
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST
    });
    PMTApiRestaurant.getRestaurantForGroup(
      restaurant.id,
      restaurantsGroup,
      RestaurantAction.receiveRestaurantForGroup,
      RestaurantAction.receiveRestaurantForGroupError
    );
  }

  static receiveRestaurantForGroup(restaurant: Restaurant, restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_FOR_GROUP_SUCCESS,
      restaurant,
      restaurantsGroup
    });
  }

  static receiveRestaurantForGroupError(apiError: ApiError) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_FOR_GROUP_FAILURE,
      apiError
    });
  }

  //
  // Create
  //

  static createRestaurant(restaurant) {
    PMTApiRestaurant.postRestaurant(
      restaurant,
      // Once the restaurant is created, we have to reload the main restaurants group.
      (restaurant: Restaurant) => {
        PMTApiRestaurantsGroup.getRestaurantsGroup(
          RestaurantStore.getRestaurantsGroup().id,
          true,
          (restaurantsGroup: RestaurantsGroup) => {
            RestaurantAction.receiveCreatedRestaurant(restaurant, restaurantsGroup);
          },
          RestaurantAction.receiveCreatedRestaurantError
        );
      },
      RestaurantAction.receiveCreatedRestaurantError
    );
  }

  static receiveCreatedRestaurant(restaurant: Restaurant, restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_RESTAURANT_RESPONSE_SUCCESS,
      restaurant,
      restaurantsGroup
    });
  }

  static receiveCreatedRestaurantError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_RESTAURANT_RESPONSE_FAILURE,
      apiError
    });
  }


  //
  // update
  //
  static updateRestaurant(restaurantMultipart: RestaurantMultipart) {
    PMTApiRestaurant.putRestaurantMultipart(
      RestaurantStore.getRestaurantId(),
      restaurantMultipart,
      RestaurantAction.receiveUpdateRestaurant,
      RestaurantAction.receiveUpdateRestaurantError
    );
  }

  static receiveUpdateRestaurant(restaurant: Restaurant) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS,
      restaurant
    });
  }

  static receiveUpdateRestaurantError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_RESTAURANT_MULTIPART_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // RestaurantsGroup - retrieve
  //
  static retrieveRestaurantsGroup(restaurantsGroupId: string) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANTS_GROUP
    });
    PMTApiRestaurantsGroup.getRestaurantsGroup(
      restaurantsGroupId,
      true,
      RestaurantAction.receiveRestaurantsGroup,
      RestaurantAction.receiveRestaurantsGroupError
    );
  }

  static receiveRestaurantsGroup(restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANTS_GROUP_SUCCESS,
      restaurantsGroup
    });
  }

  static receiveRestaurantsGroupError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANTS_GROUP_FAILURE,
      apiError
    });
  }

  //
  // RestaurantsGroup - create
  //

  static createRestaurantsGroup(restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.POST_RESTAURANTS_GROUP,
      restaurantsGroup
    });

    PMTApiRestaurantsGroup.postRestaurantsGroup(
      restaurantsGroup,
      RestaurantAction.receiveCreatedRestaurantsGroup,
      RestaurantAction.receiveCreatedRestaurantsGroupError
    );
  }

  static receiveCreatedRestaurantsGroup(restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_RESTAURANTS_GROUP_SUCCESS,
      restaurantsGroup
    });
  }

  static receiveCreatedRestaurantsGroupError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_RESTAURANTS_GROUP_FAILURE,
      apiError
    });
  }

  //
  // RestaurantsGroup - update
  //

  static updateRestaurantsGroup(restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PUT_RESTAURANTS_GROUP,
      restaurantsGroup
    });

    PMTApiRestaurantsGroup.putRestaurantsGroup(
      restaurantsGroup,
      RestaurantAction.receiveUpdatedRestaurantsGroup,
      RestaurantAction.receiveUpdatedRestaurantsGroupError
    );
  }

  static receiveUpdatedRestaurantsGroup(restaurantsGroup: RestaurantsGroup) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_RESTAURANTS_GROUP_SUCCESS,
      restaurantsGroup
    });
  }

  static receiveUpdatedRestaurantsGroupError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_RESTAURANTS_GROUP_FAILURE,
      apiError
    });
  }

  //
  // Restaurant group roles
  //

  static retrieveRestaurantsGroupRoles(restaurantsGroupId: string) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_RESTAURANT_ROLES,
      restaurantsGroupId
    });

    PMTApiRole.getRestaurantsGroupRoles(
      restaurantsGroupId,
      RestaurantAction.receiveRestaurantsGroupRoles,
      RestaurantAction.receiveRestaurantGroupRolesError
    );
  }

  static receiveRestaurantsGroupRoles(proRolesList: ProRolesList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANT_ROLES_SUCCESS,
      proRolesList
    });
  }

  static receiveRestaurantGroupRolesError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANT_ROLES_FAILURE,
      apiError
    });
  }

  //
  // Update role
  //

  static updateRole(proRole: ProRole) {
    PMTApiRole.putRole(
      proRole,
      RestaurantAction.receiveUpdateRole,
      RestaurantAction.receiveUpdateRoleError
    );
  }

  static receiveUpdateRole(proRole: ProRole) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ROLE_RESPONSE_SUCCESS,
      proRole
    });
  }

  static receiveUpdateRoleError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ROLE_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // Create role
  //

  static createRole(proRole: ProRole) {
    PMTApiRole.postRole(
      proRole,
      RestaurantAction.receiveCreateRole,
      RestaurantAction.receiveCreateRoleError
    );
  }

  static receiveCreateRole(proRole: ProRole) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_ROLE_RESPONSE_SUCCESS,
      proRole
    });
  }

  static receiveCreateRoleError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.POST_ROLE_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // Delete role
  //

  static deleteRole(proRole: ProRole) {
    PMTApiRole.deleteRole(
      proRole,
      RestaurantAction.receiveDeleteRole,
      RestaurantAction.receiveDeleteRoleError
    );
  }

  static receiveDeleteRole(proRole: ProRole) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.DELETE_ROLE_RESPONSE_SUCCESS,
      proRole
    });
  }

  static receiveDeleteRoleError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.DELETE_ROLE_RESPONSE_FAILURE,
      apiError
    });
  }
}
